module.exports = __webpack_public_path__ + "img/1373-gore-vidal-quotes.e91f99c1.jpeg";